import theme from "../themes/themes";
import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Button, IconButton } from "../common/MaterialComponent";

export const primaryColor = css({
	color: theme.palette.primary.main,
});

export const primaryBorderColor = css({
	borderColor: theme.palette.primary.main,
});

export const LinkPrimary = styled("a")`
	color: ${theme.palette.primary.main};
`;

export const IconButtonPrimary = styled(IconButton)`
	color: ${theme.palette.primary.main};
	padding: 10px;

	&.Mui-disabled {
		opacity: 0.8 !important;
	}
`;

export const ButtonPrimary = styled(Button)`
	background-color: ${theme.palette.primary.main} !important;
	color: #fff !important;

	&.Mui-disabled {
		opacity: 0.5 !important;
	}
`;

export const primaryBorder = css({
	border: "1px solid" + theme.palette.primary.main,
});
